export const EPOCH_INTERVAL = 9600;

// NOTE could get this from an outside source since it changes slightly over time
export const BLOCK_RATE_SECONDS = 3;

interface IAddresses {
  [key: number]: { [key: string]: string };
}
export const addresses: IAddresses = {
  355113: {
    BUSD_ADDRESS: "0xbd9A5c1d9fBbBEC84633ec9Cb046C01fB79809f2",
    TOKEN_ADDRESS: "0xD89E302C8ac7AbAa4eC6016961e04692cccb6039",
    PRESALE_ADDRESS: "0xe68C27F93b8f442F2920846e8F9be961d72da3A7"
  },
};
